import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

export const cardData = [
  {
    id: "about",
    heading: "About",
    icon: <PermIdentityOutlinedIcon />,
  },
  {
    id: "experience",
    heading: "Experience",
    icon: <BusinessCenterOutlinedIcon />,
  },
  {
    id: "education",
    heading: "Education",
    icon: <SchoolOutlinedIcon />,
  },
  {
    id: "skills",
    heading: "Skills",
    icon: <StarBorderOutlinedIcon />,
  },
  // {
  //   id: "resume",
  //   heading: "Resume",
  //   icon: <FilePresentIcon />,
  //   url: "https://drive.google.com/file/d/18eBZbk5QeJLOjpXRl-MCKKnp_M3tItPC/view?usp=sharing",
  // },
  {
    id: "contact",
    heading: "Contact",
    icon: <EmailOutlinedIcon />,
  },
];

export const socialMedia = [
  {
    id: "linkedin",
    platform: "LinkedIn",
    icon: "LinkedIn",
    url: "https://www.linkedin.com/in/viswachand-akkanambattu-9aa558147/",
  },
  {
    id: "github",
    platform: "GitHub",
    icon: "GitHub",
    url: "https://www.linkedin.com/in/viswachand/",
  },
  {
    id: "instagram",
    platform: "Instagram",
    icon: "Instagram",
    url: "https://www.instagram.com/viswachandreddy/",
  },
  {
    id: "medium",
    platform: "Medium",
    icon: "Medium",
    url: "https://medium.com/@viswachand19",
  },
];
